import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const ConfigPanelWrapper = ({
  children
}) => /*#__PURE__*/_jsx(View, {
  backgroundColor: "fill-surface-default",
  "data-test-id": "properties-panel",
  paddingBlockEnd: "1200",
  overflowY: "auto",
  blockSize: "100%",
  zIndex: 1,
  borderInlineEndStyle: "solid",
  borderInlineEndWidth: "100",
  borderInlineEndColor: "border-core-default",
  children: children
});